/* Irons & Wedges · "The Look" (iwl-*) behaviour. Each block runs only if its section is on the page. */
(function () {
  if (window.__iwlInit) return; window.__iwlInit = true; // several sections include this file; run once
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Finder: rank set cards by game fit x 2 + rating for the chosen priority ---------- */
  var grid = $('.iwl-cards');
  var cards = grid ? $$('.iwl-card', grid) : [];
  var NAME = {}, R = {};
  cards.forEach(function (c) {
    var k = c.dataset.k;
    NAME[k] = c.dataset.name;
    R[k] = { f: +c.dataset.rf, d: +c.dataset.rd, c: +c.dataset.rc, w: +c.dataset.rw };
  });
  if (grid && cards.length) {
    var out = $('.iwl-choose-out');
    var GAME = { high: 'a high handicap', mid: 'a mid handicap', low: 'a low handicap' };
    var PRI = { f: 'forgiveness', d: 'distance', w: 'workability' };
    var state = { g: grid.dataset.g || 'mid', p: grid.dataset.p || 'f' };
    var base = cards.map(function (c) { return c.dataset.k; });
    var rank = function (anim) {
      var order = base.slice().sort(function (a, b) {
        var ca = cards[base.indexOf(a)], cb = cards[base.indexOf(b)];
        var sa = (+ca.dataset['fit' + state.g]) * 2 + R[a][state.p];
        var sb = (+cb.dataset['fit' + state.g]) * 2 + R[b][state.p];
        return sb - sa || base.indexOf(a) - base.indexOf(b);
      });
      order.forEach(function (k, i) {
        var el = cards[base.indexOf(k)];
        el.style.order = i;
        el.classList.toggle('pick', i === 0);
      });
      grid.setAttribute('data-p', state.p);
      var top = cards[base.indexOf(order[0])];
      if (out) out.innerHTML = '<b>Best match for ' + GAME[state.g] + ' who wants more ' + PRI[state.p] + ': ' + top.dataset.name + '.</b> ' + (top.dataset.why || '');
      $$('.iwl-fopts button').forEach(function (b) {
        var on = b.dataset.g ? b.dataset.g === state.g : b.dataset.p === state.p;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (anim) { grid.classList.remove('moved'); void grid.offsetWidth; grid.classList.add('moved'); }
    };
    $$('.iwl-fopts button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.g) state.g = b.dataset.g; else state.p = b.dataset.p;
        rank(true);
      });
    });
    rank(false);
  }

  /* ---------- Rating definitions (dialog) ---------- */
  var dlg = $('#iwl-def');
  var defsEl = $('#iwl-defs');
  if (dlg && defsEl) {
    var DEF = {};
    try { DEF = JSON.parse(defsEl.textContent); } catch (e) {}
    var open = function (k) {
      var d = DEF[k]; if (!d) return;
      $('#iwl-def-t').textContent = d.t;
      $('#iwl-def-b').textContent = d.b;
      $('#iwl-def-h').textContent = d.h;
      var rows = Object.keys(R).map(function (s) {
        return '<div class="row"><span>' + NAME[s] + '</span><i class="iwl-bar" style="--v:' + R[s][k] + '"></i><b>' + R[s][k] + '</b></div>';
      }).join('');
      $('#iwl-def-r').innerHTML = rows;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.iwl-defbtn');
      if (b) { e.preventDefault(); open(b.dataset.def); }
    });
    $('#iwl-def-x').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  /* ---------- Lofts: set tiles swap the loft strip ---------- */
  $$('.iwl-lofts-sec').forEach(function (sec) {
    var btns = $$('.iwl-sets button', sec), row = $('.iwl-lofts', sec), note = $('.iwl-lofts-note', sec);
    var show = function (b) {
      btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var clubs = (b.dataset.clubs || '').split(','), lofts = (b.dataset.lofts || '').split(',');
      row.innerHTML = clubs.map(function (c, i) {
        return '<div><span class="club">' + c.trim() + '</span><div class="deg">' + (lofts[i] || '').trim() + '<sup>&deg;</sup></div></div>';
      }).join('');
      note.textContent = b.dataset.note || '';
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b); }); });
    if (btns[0]) show(btns[0]);
  });

  /* ---------- Wedge singles picker ---------- */
  $$('.iwl-singles').forEach(function (box) {
    var btns = $$('.iwl-lofts3 button', box), img = $('img', box), spec = $('.wspec', box), shop = $('.iwl-shop-single', box), price = $('.iwl-price', box);
    var pick = function (b) {
      btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (b.dataset.img) { img.src = b.dataset.img; img.alt = b.dataset.alt || ''; }
      spec.textContent = b.dataset.spec || '';
      shop.href = b.dataset.url; shop.textContent = 'Shop ' + b.dataset.loft + '°';
      if (b.dataset.price) price.textContent = b.dataset.price;
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
    var start = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
    if (start) pick(start);
  });

  /* ---------- Sticky bar after the hero leaves the screen (phones) ---------- */
  var st = $('.iwl-sticky'), hero = $('.iwl-hero');
  if (st && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { st.classList.toggle('on', !e[0].isIntersecting); }).observe(hero);
  }
})();
